// extracted by mini-css-extract-plugin
export default {"container":"ObjectAlign_container__CXfsZ"};